export enum LoaderMutationTypes {
    SHOW = 'SHOW',
    HIDE = 'HIDE',
    PENDING = 'PENDING',
    DONE = 'DONE'
}
